<template>
  <section class="t-tab-content" :index="index" data-test-id="tab-content">
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: 't-tab-content',
  props: {
    index: { type: String, default: 'Tab Content Index' },
  },
};
</script>

<style lang="scss" scoped>
.t-tab-content {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-sizing: border-box;
  max-height: 100%;
  padding: 24px;
}
</style>
